module.exports = __webpack_public_path__ + "img/feature_buy_zh.c3102cc0.png";